var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16076",
    "data-name": "Group 16076",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19332",
    "data-name": "Path 19332",
    d: "M76,0A76,76,0,1,1,0,76,76,76,0,0,1,76,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19332_-_Outline",
    "data-name": "Path 19332 - Outline",
    d: "M76,4.75A71.25,71.25,0,0,0,25.619,126.381,71.25,71.25,0,1,0,126.381,25.619,70.783,70.783,0,0,0,76,4.75M76,0A76,76,0,1,1,0,76,76,76,0,0,1,76,0Z",
    fill: "#ffd055"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12467",
    "data-name": "Group 12467",
    transform: "translate(36.99 39.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame",
    transform: "translate(1.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10473",
    "data-name": "Group 10473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10472",
    "data-name": "Group 10472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16923",
    "data-name": "Path 16923",
    d: "M258.536,3.478A11.854,11.854,0,0,0,250.053,0H238.6V4.581h11.368a7.532,7.532,0,0,1,7.465,7.466V24.178h4.581V11.962A12.213,12.213,0,0,0,258.536,3.478Z",
    transform: "translate(-186.021 1.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16923_-_Outline",
    "data-name": "Path 16923 - Outline",
    d: "M238.35-.25h12.64a13.081,13.081,0,0,1,9.323,3.826,13.411,13.411,0,0,1,3.826,9.323V26.3h-6.956V12.984a6.345,6.345,0,0,0-6.278-6.278H238.35Zm23.414,24.178V12.9a11.034,11.034,0,0,0-3.147-7.66,10.71,10.71,0,0,0-7.628-3.114H240.725V4.331h10.18a8.719,8.719,0,0,1,8.653,8.653V23.928Z",
    transform: "translate(-186.959 0.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16924",
    "data-name": "Path 16924",
    d: "M10.187,255.706a7.444,7.444,0,0,1-2.206-5.26V238.4H3.4v12.131a12.213,12.213,0,0,0,3.478,8.483,12.578,12.578,0,0,0,8.568,3.478H26.815v-4.581H15.447A7.445,7.445,0,0,1,10.187,255.706Z",
    transform: "translate(-2.212 -186.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16924_-_Outline",
    "data-name": "Path 16924 - Outline",
    d: "M28.94,264.618H16.384a13.828,13.828,0,0,1-9.375-3.795l-.049-.048a13.4,13.4,0,0,1-3.81-9.307V238.15h6.956v13.234a6.344,6.344,0,0,0,6.278,6.278H28.94ZM8.648,259.1a11.367,11.367,0,0,0,7.736,3.139h10.18v-2.206H16.384a8.719,8.719,0,0,1-8.653-8.653V240.525H5.525v10.944A11.03,11.03,0,0,0,8.648,259.1Z",
    transform: "translate(-3.15 -187.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16925",
    "data-name": "Path 16925",
    d: "M257.349,250.531A7.532,7.532,0,0,1,249.883,258H238.6v4.581h11.368a12.214,12.214,0,0,0,8.484-3.478,11.853,11.853,0,0,0,3.478-8.483V238.4h-4.581Z",
    transform: "translate(-186.021 -186.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16925_-_Outline",
    "data-name": "Path 16925 - Outline",
    d: "M250.905,264.7H238.35v-6.956h12.471a6.344,6.344,0,0,0,6.278-6.278V238.15h6.956v13.4a13.081,13.081,0,0,1-3.826,9.323A13.41,13.41,0,0,1,250.905,264.7Zm-10.18-2.375h10.18a11.034,11.034,0,0,0,7.661-3.147,10.71,10.71,0,0,0,3.114-7.627V240.525h-2.206v10.944a8.719,8.719,0,0,1-8.653,8.653h-10.1Z",
    transform: "translate(-186.959 -187.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16926",
    "data-name": "Path 16926",
    d: "M7.278,3.478A11.854,11.854,0,0,0,3.8,11.962V24.093H8.381V11.962A7.532,7.532,0,0,1,15.847,4.5H27.215V0H15.762A12.214,12.214,0,0,0,7.278,3.478Z",
    transform: "translate(-2.528 1.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16926_-_Outline",
    "data-name": "Path 16926 - Outline",
    d: "M16.7-.25H29.34V6.621H16.784A6.345,6.345,0,0,0,10.506,12.9V26.218H3.55V12.9A13.082,13.082,0,0,1,7.376,3.576,13.411,13.411,0,0,1,16.7-.25ZM26.965,2.125H16.7a11.034,11.034,0,0,0-7.66,3.147A10.71,10.71,0,0,0,5.925,12.9V23.843H8.131V12.9a8.719,8.719,0,0,1,8.653-8.653h10.18Z",
    transform: "translate(-3.465 0.25)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Line_85",
    "data-name": "Line 85",
    d: "M79.487,6.375H0V-.75H79.487Z",
    transform: "translate(0 35.745)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconScan);
export default __webpack_public_path__ + "static/media/general-icon-scan.ad6778f058986aa909de4a241b56b503.svg";
export { ForwardRef as ReactComponent };